import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function useTrackPageView() {
  const location = useLocation();

  const isInitialPageView = useRef(true);

  useEffect(() => {
    if (!window?.tap?.pageView) {
      if (!isInitialPageView.current) {
        window.tap.event('page-view');
      }
    } else {
      const payload = {};
      if (isInitialPageView.current) {
        payload.qry = null;
      }

      window?.tap?.pageView(payload);
    }

    if (isInitialPageView.current) {
      isInitialPageView.current = false;
    }
  }, [location]);
}
